import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
  type SimpleChanges,
} from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { SymbolComponent } from '@core/symbol-legacy';
import { TimeAgoPipe } from '@core/time-legacy';
import {
  DividerComponent,
  HeadingComponent,
  IconComponent,
  type IconToken,
  RtTooltip,
} from '@core/user-interface-legacy';
import type { LayoutBoardCard } from '@core/views-util';
import { assigneeToAvatarUser } from '@tellent-ask-hr/core-smart-ui';
import type { AskTicketBoardItem } from '@tellent-ask-hr/core-types';
import { priorityColorMap } from '@tellent-ask-hr/templates-util';

import { AskTicketsDataSourceService } from '../ask-tickets-data-source.service';

@Component({
  selector: 'ask-ticket-board-item',
  imports: [
    CommonModule,
    HeadingComponent,
    DividerComponent,
    AdminsAvatarsComponent,
    SymbolComponent,
    IconComponent,
    TimeAgoPipe,
    TranslatePipe,
    MomentModule,
    RtTooltip,
  ],
  templateUrl: './ask-ticket-board-item.component.html',
  styleUrl: './ask-ticket-board-item.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card rt-card-clickable',
    '(click)': 'onClick()',
  },
})
export class AskTicketBoardItemComponent implements LayoutBoardCard<AskTicketBoardItem> {
  private readonly askTicketsDataSourceService = inject(AskTicketsDataSourceService);
  protected readonly priorityColorMap: Record<
    Exclude<AskTicketBoardItem['priority'], null>,
    IconToken
  > = priorityColorMap;

  @Input() public record: LayoutBoardCard<AskTicketBoardItem>['record'];
  @Input() public fieldsVisibilityMap: LayoutBoardCard<AskTicketBoardItem>['fieldsVisibilityMap'];
  @Input() public isSelected: LayoutBoardCard<AskTicketBoardItem>['isSelected'];

  @Output() public select = new EventEmitter();

  protected assignees = signal<AvatarUser[]>([]);
  protected requesterName = signal('');

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.record && this.record) {
      const { assignees, requester } = this.record;
      this.assignees.set(assignees.map(assignee => assigneeToAvatarUser(assignee)));
      this.requesterName.set(`${requester.firstName} ${requester.lastName}`);
    }
  }

  public onClick() {
    this.askTicketsDataSourceService.onRecordClick(this.record);
  }
}
